/* eslint-disable no-new */
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import AlertAlert from 'vue-alert-alert'
import VModal from 'vue-js-modal'
import SocialSharing from 'vue-social-sharing'
import VueScrollTo from 'vue-scrollto'
import VueAnalytics from 'vue-analytics'

// TODO: See if we're still using this. Did a quick search replace and I don't think so, but don't want to touch it.
import VueSwal from 'vue-swal'

import {
  formatNumberAsUSD,
  formatNumberAsUSDNoCents,
  momentDateTime,
  momentDateTimeShort,
} from '@/services/utils/filters'

// Font Awesome Icons
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faTimes,
  faBars,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faReply,
  faShare,
  faUser,
  faMoneyBillAlt,
  faUsers,
  faComments,
  faBell,
  faEnvelope,
  faSearch,
  faPlus,
  faSeedling,
  faCogs,
  faChalkboardTeacher,
  faChild,
  faFemale,
  faHouseDamage,
  faSyncAlt,
  faUserCircle,
} from '@fortawesome/free-solid-svg-icons'
import {
  faFacebook,
  faLinkedin,
  faTwitter,
  faWhatsapp,
  faYoutube,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import * as VueGoogleMaps from 'vue2-google-maps'

import App from '@/App.vue'
import router from '@/router'
import store from './store'

/* Vue plug-ins */
Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueScrollTo)
Vue.use(AlertAlert)
Vue.use(VueSwal)
Vue.use(SocialSharing)
Vue.use(VModal, { dialog: true })
Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'places',
  },
})

/* Pass router instance to automatically track page views on Google Analytics */
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA_ID,
  router,
})

Vue.filter('momentDateTime', momentDateTime)
Vue.filter('momentDateTimeShort', momentDateTimeShort)
Vue.filter('formatNumberAsUSD', formatNumberAsUSD)
Vue.filter('formatNumberAsUSDNoCents', formatNumberAsUSDNoCents)

library.add(
  faTimes,
  faBars,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faReply,
  faShare,
  faUser,
  faMoneyBillAlt,
  faUsers,
  faComments,
  faBell,
  faSearch,
  faPlus,
  faSeedling,
  faCogs,
  faChalkboardTeacher,
  faChild,
  faFemale,
  faHouseDamage,
  faSyncAlt,
  faUserCircle,
  faEnvelope,
  faFacebook,
  faLinkedin,
  faTwitter,
  faWhatsapp,
  faYoutube,
  faInstagram,
)
Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
})

window.Intercom('boot', {
  app_id: process.env.VUE_APP_INTERCOM_ID,
})
